import * as React from 'react';
import { FC } from 'react';

import { HStack } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import Link from 'components/link';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import theme from './theme';

export interface ISubcategoryBreadcrumbs {
  currentSectionName: string;
}

const StyledLink = Link.withConfig({
  color: theme.wrapperColor,
});

export const SubcategoryBreadcrumbs: FC<React.PropsWithChildren<ISubcategoryBreadcrumbs>> = ({
  currentSectionName,
}) => {
  return (
    <HStack paddingTop="$4" alignSelf="center" flexWrap="wrap" justifyContent="center">
      <StyledLink to={routes.supportCategories} isInline isUnderlined>
        {t('supportTopicsAll')}
      </StyledLink>
      <Typography fontSize="lg" style={{ alignSelf: 'flex-start' }}>
        {' / ' + currentSectionName}
      </Typography>
    </HStack>
  );
};
